// ルートパス定数を定義
export const LOGIN_PATH = '/login-v2';
export const QUOTATIONS_PATH = '/quotations-v2';
export const MEDICINES_PATH = '/medicines-v2';
export const DRAFT_QUOTATIONS_PATH = '/draft-quotation-v2';
export const PRICE_SHOW_PATH = '/price-show-v2';
